import Resizer from "react-image-file-resizer";

/** 
  *Image resizer utility
  *@params {file} - File
  returns Promise<File>
*/
export const resizeFile = (file) =>
  new Promise((resolve) => {
    Resizer.imageFileResizer(
      file,
      1000,
      1000,
      "JPEG",
      100,
      0,
      (uri) => {
        resolve(uri);
      },
      "blob"
    );
  });

